import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { TextInput } from "../../../components/formLibs/FormLibs";
import "primeicons/primeicons.css";
import logoEcole229 from "../../../assets/images/logo.jpg";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { ErrorMsg } from "../../../components/includes/styles/Styles";
import Authentification from "../../../api/Authentification";
import { Toast } from "primereact/toast";
import { ProgressSpinner } from "primereact/progressspinner";
import { routes } from "../../../routes";

const ForgotPassword = () => {
  const toast = useRef(null);
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const schema = Yup.object({
    email: Yup.string()
      .required("L'eamil est obligatoire")
      .email("Email invalide"),
  }).required();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const reset = (data) => {
    setLoading(true);
    Authentification.resetPassword(data)
      .then((res) => {
        console.log("res", res);
        if (res.data.error) {
          toast.current.show({
            severity: "error",
            summary: "Erreur",
            detail: "Compte inactif. Veuillez activer votre compte",
            life: 3000,
          });
          setLoading(false);
        } else {
          setLoading(false);
          setDisabled(true);
          toast.current.show({
            severity: "success",
            summary: "Succès",
            detail:
              "Un lien de réinitialisation vient d'être envoyé à votre adresse email",
            life: 3000,
          });
        }
      })
      .catch((err) => {
        toast.current.show({
          severity: "error",
          summary: "Erreur",
          detail: "Identifiant incorect",
          life: 3000,
        });
        setLoading(false);
      });
  };
  return (
    <>
      <Toast ref={toast} />
      <div className="auth__logo">
        <img src={logoEcole229} alt="logo_ecole229" />
      </div>
      <p className="mb-5 subtitle text-center">
        Entrer votre adresse email pour récupérer votre compte !
      </p>
      <div className="auth__form">
        <form className="form" onSubmit={handleSubmit(reset)}>
          <div className="form__item">
            <label htmlFor="Email">Email</label>
            <div className="form__item__ic_p">
              <TextInput
                type="email"
                name="email"
                label="email"
                register={register}
              />
              <i className="pi pi-envelope"></i>
            </div>
            <ErrorMsg>{errors.email?.message}</ErrorMsg>
          </div>
          <div className="form__item">
            <button type="submit" disabled={disabled}>
              Récupérer le compte{" "}
              <ProgressSpinner
                style={
                  loading
                    ? { width: "20px", height: "20px" }
                    : { width: "0px", height: "0px" }
                }
                strokeWidth="8"
                loading={loading}
              />
            </button>
          </div>
          <div className="form__item form__item--last">
            <p>
              Vous n'avez pas un compte ?{" "}
              <Link to={routes.auth + routes.register}>Créer un compte</Link>
            </p>
          </div>
        </form>
      </div>
    </>
  );
};

export default ForgotPassword;
